import { Component } from 'react';
import { FormikProps } from 'formik';
import { Locale } from '@synergy/models';

import { EditOffer } from './model/edit-offer';
import { OfferEditFormFooter } from './components/offer-edit-form-footer';
import { OfferEditFormTable } from './components/offer-edit-form-table';

interface OfferEditFormProps {
    formikProps: FormikProps<EditOffer>;
    currency: string;
    locale: Locale;
    mediaBaseUrl: string;
    readonly: boolean;
}

export const OfferEditForm = class OfferEditFormBase extends Component<OfferEditFormProps> {
    public render() {
        const { currency, locale, formikProps, readonly } = this.props;

        return (
            <div>
                <OfferEditFormTable formikProps={formikProps} currency={currency} locale={locale} readonly={readonly} />
                <OfferEditFormFooter
                    formikProps={formikProps}
                    currency={currency}
                    mediaBaseUrl={this.props.mediaBaseUrl}
                    readonly={readonly}
                />
            </div>
        );
    }
};
